import { z } from 'zod'

export const PiloteRegionRecordZod = z.object({
  id: z.number(),
  version: z.number(),
  central_id: z.number(),
  name: z.string(),
  abbreviation: z.string().nullable(),
  city: z.string(),
  province: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  active: z.boolean(),
})
